import hacktimer from './services/HackTimer/HackTimer' // must be first import
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { History } from './XtractInit' // must be before store import
import React from 'react'
import jQuery from 'jquery'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { draggable, resizeable } from 'Helper/interactable'
import { faArrowsAltH, faStar } from '@fortawesome/pro-light-svg-icons'
import Store from './store'
import App from './components/App.jsx'
import CoverageCollector from './components/CoverageCollector.jsx'
import './SagaInit' // must come last
import globalConfig from 'Helper/configHelpers'
// even though it isn't used here, we need to pre-load the loading window so its available immediately.
import LoadingWindow from 'GeneralUI/Window/LoadingWindow.jsx'

// setup to properly load ace editor workers
import jsWorkerUrl from 'ace-builds/src-noconflict/worker-javascript'
import jsonWorkerUrl from 'ace-builds/src-noconflict/worker-json'
import luaWorkerUrl from 'ace-builds/src-noconflict/worker-lua'
const ace = require('ace-builds/src-noconflict/ace')
ace.config.set('workerPath', globalConfig.basepath + 'dist/')
ace.config.setModuleUrl('ace/mode/javascript_worker', jsWorkerUrl)
ace.config.setModuleUrl('ace/mode/json_worker', jsonWorkerUrl)
ace.config.setModuleUrl('ace/mode/lua_worker', luaWorkerUrl)
ace.config.set('loadWorkerFromBlob', false)

// build fontawesome library
library.add(fas, far, fab, faArrowsAltH, faStar)

// require jquery
window.jQuery = jQuery

// require the parts of bootstrap we are using
require('./Helper/bootstrap_js/dropdown.js')

// Import css and fonts
require('./styles/indexStyles.styl')

// initialize draggable and resizeable windows
draggable()
resizeable()

// Hot reloading reducers?
if (module.hot) {
  module.hot.accept('./reducers/rootReducer', () => {
    const nextRootReducer = require('./reducers/rootReducer').default
    Store.replaceReducer(nextRootReducer)
  })
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Provider store={Store}>
    <BrowserRouter history={History}>
      <App />
      {globalConfig?.coverage_enabled && <CoverageCollector />}
    </BrowserRouter>
  </Provider>
)

// expose store when run in Cypress
if (window.Cypress) {
  window.store = Store
}
